import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'app/core/app-config/state/models';
import { Observable } from 'rxjs';

import { FilterInterface, FilterItemInterface, SiteFilterInterface } from '../models';
import { CreateManagementSiteFilterItem } from '../state/actions/site-filter-create.action';
import { DeleteManagementSiteFilterItem } from '../state/actions/site-filter-delete.action';
import { LoadManagmentSiteFilter, LoadSiteFilter } from '../state/actions/site-filter-load.action';
import { UpdateManagementSiteFilterItem, UpdateManagmentSiteFilterCategory, UpdateSiteFilter } from '../state/actions/site-filter-update.action';

import { SiteFilterServiceInterface } from './site-filter-service.interface';

@Injectable()
export class SiteFilterService implements SiteFilterServiceInterface {
  constructor(private readonly _store: Store<AppStateInterface>) {
    this.onInit();
  }

  public onInit(): void {}

  public getFilter(): Observable<Readonly<SiteFilterInterface>> {
    this._store.dispatch(new LoadSiteFilter());

    return this._store.select(({ siteFilter }: AppStateInterface) => siteFilter.siteFilters);
  }

  public getFilterForProfile(): Observable<Readonly<SiteFilterInterface>> {
    return this._store.select(({ siteFilter }: AppStateInterface) => siteFilter.siteFilters);
  }


  public updateFilter(siteFilter: SiteFilterInterface): Observable<Readonly<SiteFilterInterface>> {
    this._store.dispatch(new UpdateSiteFilter(siteFilter));

    return this._store.select(({ siteFilter }: AppStateInterface) => siteFilter.siteFilters);
  }

  public getAllFilters(): Observable<Readonly<FilterInterface[]>> {
    this._store.dispatch(new LoadManagmentSiteFilter());

    return this._store.select(({ siteFilter }: AppStateInterface) => siteFilter.managementFilters);
  }

  public updateFilterCategory(filterToUpdate: FilterInterface): void {
    this._store.dispatch(new UpdateManagmentSiteFilterCategory(filterToUpdate));
  }

  public createFilterItem(filterId: number, itemToCreate: FilterItemInterface): void {
    this._store.dispatch(new CreateManagementSiteFilterItem({ filterId, filterItem: itemToCreate }));
  }

  public updateFilterItem(filterId: number, itemToUpdate: FilterItemInterface): void {
    this._store.dispatch(new UpdateManagementSiteFilterItem({ filterId, filterItem: itemToUpdate }));
  }

  public deleteFilterItem(filterId: number, itemToDelete: FilterItemInterface): void {
    this._store.dispatch(new DeleteManagementSiteFilterItem({ filterId, filterItem: itemToDelete }));
  }

}
